<template>
    <div id="main-header">
    <!--nav-->
        <nav class="navbar navbar-default no-margin app-sidebar-nav">
            <div class="navbar-header fixed-brand">
                <button type="button" class="navbar-toggle collapsed" data-toggle="collapse" id="menu-toggle">
                    <span class="glyphicon glyphicon-th-large" aria-hidden="true"></span>
                </button>
                <button class="navbar-toggle collapse show" data-toggle="collapse" id="menu-toggle-2">
                    <img src="/static/images/menubar.png" alt="Menu" class="menubar">
                </button>
                <a class="navbar-brand" href="javascript:void(0)"><img src="/static/images/logo.png" alt="Velocity Vehicle Group"></a>
            </div>
            <!-- <div class="collapse navbar-collapse" id="bs-example-navbar-collapse-1">
                <ul class="nav navbar-nav">
                    <li class="active">
                        <button class="navbar-toggle collapse in" data-toggle="collapse" id="menu-toggle-2">
                            <img src="/static/images/menubar.png" alt="Menu" class="menubar">
                        </button>
                    </li>
                </ul>
            </div> -->
            <div>
            <div class="notification">
                <a class="header-filter" href="javascript:void(0)" v-on:click.prevent="resetAllFilters()">
                    Reset all filters
                </a>
                <a href="javascript:void(0)" class="ml-4" v-on:click.prevent="refreshWindow()">
                    <img src="/static/images/refresh.png" alt="Refresh" title="Refresh">
                </a>
                <a class="ml-4" v-if="isShowExportDatabaseButton" href="javascript:void(0)" v-on:click.prevent="exportDatabase()">
                    <img src="/static/images/database_export_icon.png" alt="Notification" title="Export Database">
                </a>
            </div>
            <!--notification-->
            <!--userinfo-->
            <div class="user-info">
                <div class="user-info-container">
                    <div class="dropdown">
                        <button type="button" class="btn btn-primary dropdown-toggle" data-toggle="dropdown">
                            <div class="dropdown-user">
                                <div class="username-letter">{{iconLetters}}</div>
                                <div class="dropdown-user-right">
                                    <div class="username">{{firstName}} {{lastName}}</div>
                                    <br/>
                                    <div class="usermailid">{{username}}</div>
                                </div>
                            </div>
                        </button>
                        <div class="dropdown-menu">
                            <!-- <a class="dropdown-item" href="javascript:void(0)">My Profile</a> -->
                            <!-- <a class="dropdown-item" href="javascript:void(0)">Inbox</a> -->
                            <!-- <a class="dropdown-item" href="javascript:void(0)">Account Setting</a> -->
                            <a class="dropdown-item" href="javascript:void(0)" v-on:click.prevent="logout()">Logout</a>
                        </div>
                    </div>
                </div>
                <a href="javascript:void(0)" id="scroll" title="Scroll to Top" style="display: none;">Top<span></span></a>
            </div>
            </div>
            <!--userinfo-->
            <!-- bs-example-navbar-collapse-1 -->
        </nav>
    </div>
    <!--nav-->
</template>

<script>

    import Vue from 'vue';
    import {frontDomain,ssoDomain} from '../../config'
    import EventBus from '.././event-bus';
    import {HTTP} from '../../http-common';
    var self;

    export default {
        name: 'Header',
        components: {
        },
        data() {
            return {
                username: '',
                firstName: '',
                lastName: '',
                iconLetters: '',
                isShowExportDatabaseButton: false,
            }
        },

        beforeMount: function () {
            self = this;
        },
        mounted: function () {
            self = this;
            let userObj = JSON.parse(localStorage.getItem('user_obj'));
            if (typeof (userObj) != "undefined" && userObj != null && userObj != 'null' && userObj != '') {
                if(userObj['id'] == 1 || userObj['email'] == 'salem@vvgtruck.com') {
                    self.isShowExportDatabaseButton = true;
                }
            }
            $(window).scroll(function () {
                if ($(this).scrollTop() > 100) {
                    $('#scroll').fadeIn();
                } else {
                    $('#scroll').fadeOut();
                }
            });
            $('#scroll').click(function () {
                $("html, body").animate({
                    scrollTop: 0
                }, 600);
                return false;
            });
        },
        methods: {
            refreshWindow: function() {
                location.reload(true);
            },
            logout: function () {
                var custObj = JSON.parse(localStorage.getItem('customer_obj'));
                var userObj = JSON.parse(localStorage.getItem('user_obj'));
                let current_build = window.localStorage.getItem("build_version");
                if (custObj != null && custObj !== "") {
                    localStorage.clear();
                    localStorage.setItem("build_version", current_build);
                    self.$router.push("/");
                }
                if (userObj != null && userObj !== "") {
                    localStorage.clear();
                    localStorage.setItem("build_version", current_build);
                    let ssoLogin = process.env.SSO_lOGIN;
                    let isNonVVGDealer = process.env.NON_VVG_DEALER;
                    if(ssoLogin && isNonVVGDealer == 'NO'){
                        let appSlug = process.env.PROJECT_SLUG;
                        let ssoUrl = process.env.SSO_ROOT_URL;
                        let appUrl = process.env.FRONT_ROOT_URL;
                        let logoutUrl = ssoUrl+'/logout?redirect_url='+appUrl+'/admin'+'&slug='+appSlug;
                        window.location.href = logoutUrl;
                    }else{
                        self.$router.push("/admin");
                    }
                }
            },
            resetAllFilters: function() {
                localStorage.removeItem("filters");
                location.reload(true);
            },
            exportDatabase: function() {
                var config = {
                    headers: {
                        Authorization:localStorage.getItem("access_token")
                    }
                };
                var fields = {
                };
                HTTP.post("/database/dump", fields, config)
                    .then(function(response) {
                        location.href = response.data.content;
                    })
                    .catch(function(err) {
                        if (err.response.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (err.response.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("api_token");
                                localStorage.removeItem("profile_image");
                                //self.$router.push("/login");
                                //EventBus.$emit("logged-in", true, "", "");
                            }
                        }
                    });
            }
        },
    }
    EventBus.$on('login-user-info', function (isLogin, user_name, first_name, last_name) {
        if(typeof (self) != "undefined"){
            self.username = user_name;
            if(first_name != null || last_name != null) {
                self.firstName = first_name;
                self.lastName = last_name;
            } else {
                self.firstName = "NA";
                self.lastName = "";
            }
            //First Two Characters in Upper Case of Username in iconLetters
            self.iconLetters = self.username.substring(0,2).toUpperCase();
        }
    });
</script>



// WEBPACK FOOTER //
// src/components/partials/Header.vue